import React, {
  ReactElement,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react'

export type TSignedOutNavMobileContext = {
  activeItem: string
  handleCloseMobileNav: () => void
  isHamburgerOpen: boolean
  setActiveItem: (item: string) => void
  setIsHamburgerOpen: (flag: boolean) => void
}

const SignedOutNavMobileContext = React.createContext<
  TSignedOutNavMobileContext | undefined
>(undefined)

export const useSignedOutNavMobileContext = () => {
  const context = useContext(SignedOutNavMobileContext)

  if (context === undefined) {
    throw new Error(
      'useSignedOutNavMobileContext must be wrapped with SignedOutNavMobileProvider'
    )
  }

  return context
}

export const SignedOutNavMobileProvider = ({
  children,
}: {
  children: ReactNode
}): ReactElement => {
  const [activeItem, setActiveItem] = useState<string>(null)
  const [isHamburgerOpen, setIsHamburgerOpen] = useState<boolean>(false)

  const handleCloseMobileNav = useCallback(() => {
    setIsHamburgerOpen(false)
    setActiveItem(null)
  }, [])

  const contextValue = useMemo(
    () => ({
      activeItem,
      handleCloseMobileNav,
      isHamburgerOpen,
      setActiveItem,
      setIsHamburgerOpen,
    }),
    [
      activeItem,
      handleCloseMobileNav,
      isHamburgerOpen,
      setActiveItem,
      setIsHamburgerOpen,
    ]
  )

  return (
    <SignedOutNavMobileContext.Provider value={contextValue}>
      {children}
    </SignedOutNavMobileContext.Provider>
  )
}
